import React from 'react';
import LegalPage from './LegalPage';

const PrivacyPolicyPage = () => {
  return (
    <LegalPage title="Privacy Policy" slug="privacy-policy" lastUpdated="January 2026">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">1. Introduction</h2>
        <p className="text-zinc-700 leading-relaxed mb-4">
          Welcome to Indicraft. We respect your privacy and are committed to protecting your personal data. This privacy policy explains how we collect, use, and safeguard your information when you visit our website or make a purchase.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">2. Information We Collect</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">We collect the following types of information:</p>
        <ul className="list-disc pl-6 text-zinc-700 space-y-2">
          <li><strong>Personal Information:</strong> Name, email address, phone number, shipping address</li>
          <li><strong>Payment Information:</strong> Payment method details (securely processed by payment gateways)</li>
          <li><strong>Order Information:</strong> Purchase history, product preferences</li>
          <li><strong>Technical Information:</strong> IP address, browser type, device information</li>
          <li><strong>Usage Data:</strong> Pages visited, time spent on site, navigation patterns</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">3. How We Use Your Information</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">We use your information to:</p>
        <ul className="list-disc pl-6 text-zinc-700 space-y-2">
          <li>Process and fulfill your orders</li>
          <li>Send order confirmations and shipping updates</li>
          <li>Provide customer support</li>
          <li>Improve our website and services</li>
          <li>Send marketing communications (with your consent)</li>
          <li>Prevent fraud and enhance security</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">4. Information Sharing</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">
          We do not sell your personal information. We may share your data with:
        </p>
        <ul className="list-disc pl-6 text-zinc-700 space-y-2">
          <li><strong>Service Providers:</strong> Payment processors, shipping partners, email services</li>
          <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
          <li><strong>Business Transfers:</strong> In case of merger, acquisition, or sale of assets</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">5. Data Security</h2>
        <p className="text-zinc-700 leading-relaxed">
          We implement industry-standard security measures including SSL encryption, secure payment gateways, and regular security audits to protect your personal information.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">6. Your Rights</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">You have the right to:</p>
        <ul className="list-disc pl-6 text-zinc-700 space-y-2">
          <li>Access your personal data</li>
          <li>Correct inaccurate information</li>
          <li>Request deletion of your data</li>
          <li>Opt-out of marketing communications</li>
          <li>Withdraw consent at any time</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">7. Cookies</h2>
        <p className="text-zinc-700 leading-relaxed">
          We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. You can control cookie preferences through your browser settings.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">8. Contact Us</h2>
        <p className="text-zinc-700 leading-relaxed">
          For privacy-related questions or to exercise your rights, contact us at:<br />
          Email: privacy@indicraft.in<br />
          Phone: +91 123-456-7890
        </p>
      </section>
    </LegalPage>
  );
};

export default PrivacyPolicyPage;
